<template>
	<component :is="offeringPageType" :is-iframe="isIframe" />
</template>

<script setup lang="ts">
import { growthTechReitId, intervalFundReitIds } from '@constants/reit';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ViewInnovationFundDetails from '@components/offering-details/view-innovation-fund-details.vue';
import ViewIntervalFundDetails from '@components/offering-details/view-interval-fund-details.vue';
import ViewReitDetails from '@components/offering-details/view-reit-details.vue';
import type { Component as ComponentType } from 'vue';

interface Props {
	isIframe?: boolean;
}

withDefaults(defineProps<Props>(), {
	isIframe: false
});

const route = useRoute();

const offeringId = computed((): string => route.params.offeringId as string);

const offeringPageType = computed((): ComponentType => {
	if (offeringId.value === growthTechReitId) {
		return ViewInnovationFundDetails;
	} else if (intervalFundReitIds.includes(offeringId.value)) {
		return ViewIntervalFundDetails;
	} else {
		return ViewReitDetails;
	}
});
</script>
